"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerType = void 0;
exports.TriggerType = {
    FormSubmission: "form_submission",
    SitePublish: "site_publish",
    PageCreated: "page_created",
    PageMetadataUpdated: "page_metadata_updated",
    PageDeleted: "page_deleted",
    EcommNewOrder: "ecomm_new_order",
    EcommOrderChanged: "ecomm_order_changed",
    EcommInventoryChanged: "ecomm_inventory_changed",
    UserAccountAdded: "user_account_added",
    UserAccountUpdated: "user_account_updated",
    UserAccountDeleted: "user_account_deleted",
    CollectionItemCreated: "collection_item_created",
    CollectionItemChanged: "collection_item_changed",
    CollectionItemDeleted: "collection_item_deleted",
    CollectionItemUnpublished: "collection_item_unpublished",
};
